import {
  generateCustomShortFormVideoIdeas,
  getVideos,
  saveCustomShortVideo,
} from "./videos.service";

export const videosService = {
  getVideos,
  generateCustomShortFormVideoIdeas,
  saveCustomShortVideo,
};
